/*>
* @license
* Copyright (c) 2014-2022 ABILITY Network, Inc., an INOVALON, Inc. company. All Rights Reserved.
* 
* This computer program is CONFIDENTIAL and a TRADE SECRET of ABILITY Network, Inc.
* The receipt or possession of this program does not convey any rights to use,
* reproduce or disclose its contents in whole or in part, without the specific
* written consent of ABILITY Network, Inc. Any use, reproduction or disclosure of
* this program without the express written consent of ABILITY Network, Inc. is a
* violation of the copyright laws and may subject you to criminal prosecution.
<*/
import React from 'react'
import { BrowserRouter as Router, Route } from 'react-router-dom'
import './scss/custom.scss'
import { UserSessionConnected } from './views/UserSession/UserSession'
import { SearchResultsConnected } from './views/SearchResults/SearchResults'
import { ProductConnected } from './views/Product/Product'
import { LandingPageConnected } from './views/LandingPage/LandingPage'
import { ContentConnected } from './views/Content/Content'

const App: React.FunctionComponent = () => {
	return (
		<Router basename={process.env.PUBLIC_URL}>
			<div className="container">
				<ContentConnected />
				<SearchResultsConnected />
				<LandingPageConnected />
				<ProductConnected />
			</div>
			<UserSessionConnected />
		</Router>
	)
}

export default App
